class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.closeTimeout = null;

    // Handle top-level hover for mouse users
    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));

    // Handle click interaction
    this.mainDetailsToggle.querySelector('summary').addEventListener('click', this.onSummaryClick.bind(this));
  }

  onMouseEnter() {
    if (!window.matchMedia('(pointer: fine)').matches) return;
    
    if (this.closeTimeout) clearTimeout(this.closeTimeout);
    
    // Close other menus for a clean accordion-like transition
    this.closeOtherMenus();
    
    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.setAttribute('open', '');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
    }
  }

  onMouseLeave() {
    if (!window.matchMedia('(pointer: fine)').matches) return;

    this.closeTimeout = setTimeout(() => {
      this.close();
    }, 200); 
  }

  onSummaryClick(event) {
    // Accordion logic: Close all other menus when one is clicked
    this.closeOtherMenus();
    
    // The native <details> element will handle the toggle of the clicked menu
    // We just need to ensure aria-expanded matches the new state
    const summary = event.currentTarget;
    const isOpen = this.mainDetailsToggle.hasAttribute('open');
    summary.setAttribute('aria-expanded', !isOpen);
  }

  closeOtherMenus() {
    document.querySelectorAll('header-menu').forEach(menu => {
      if (menu !== this) {
        menu.close();
        if (menu.closeTimeout) clearTimeout(menu.closeTimeout);
      }
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
